export const getCalendarEvent = {
  GET_CALENDAR_EVENTS_REQUEST: "GET_CALENDAR_EVENTS_REQUEST",
  GET_CALENDAR_EVENTS_SUCCESS: "GET_CALENDAR_EVENTS_SUCCESS",
  GET_CALENDAR_EVENTS_ERROR: "GET_CALENDAR_EVENTS_ERROR",
};
